export default "__VITE_ASSET__3Lam1GQK__"